import { render, staticRenderFns } from "./FeaturesSlider.vue?vue&type=template&id=347dd56c&"
import script from "./FeaturesSlider.vue?vue&type=script&lang=js&"
export * from "./FeaturesSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports